import { AxiosPromise } from 'axios';
import { libApiInstance } from '../axios';
import { OfferResponse as OrderOfferResponse } from './types/offerResponse';
import { OrderStatusResponse } from './types/orderStatusResponse';

export function requestOrderOffers(signal?: AbortSignal): AxiosPromise<OrderOfferResponse[]> {
    return libApiInstance.get(`/orders/offers`, { signal });
}

export function requestOrderOfferByKey(
    offerKey: string,
    signal?: AbortSignal,
): AxiosPromise<OrderOfferResponse> {
    return libApiInstance.get(`/orders/offers/${offerKey}`, { signal });
}

export function requestOrderStatus(
    sessionId: string | undefined,
    signal?: AbortSignal,
): AxiosPromise<OrderStatusResponse> {
    return libApiInstance.get(`/orders/status/${sessionId}`, { signal });
}

export function requestRoloShareOrderOfferByKey(
    offerKey: string,
    signal?: AbortSignal,
): AxiosPromise<OrderOfferResponse> {
    return libApiInstance.get(`/roloshare/billing/offers/${offerKey}`, { signal });
}
